import * as React from "react";
const PredictiveMaintenance = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={23} fill="none">
    <path
      stroke="#fff"
      strokeWidth={2}
      d="M18 9V1H6v12h7V6H1v12h8m4 4 6-6m1-3a2 2 0 1 0 2 2"
    />
  </svg>
);
export default PredictiveMaintenance;
